import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import useTranslations from "../../i18n/useTranslations";
import Shortcut from "./Shortcut";

const FooterLinks: FC = () => {
  const {
    state: { head },
  } = useRewardCenter();
  const t = useTranslations();
  const links = head.links;

  return (
    <div data-slot="footer-links" className="mt-auto flex gap-2.5">
      {links?.sports && (
        <Shortcut href={links.sports} label={t("reward_center.links.sports")} />
      )}
      {links?.casino && (
        <Shortcut href={links.casino} label={t("reward_center.links.casino")} />
      )}
    </div>
  );
};

export default FooterLinks;
